import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  FormControlLabel,
  Radio,
  RadioGroup,
  Grid2,
} from "@mui/material";

const InitialVisitInfo = ({ openState, setOpenState, onApply }) => {
  const [selectedVisitType, setSelectedVisitType] = useState("OPD");

  const handleApply = () => {
    onApply(selectedVisitType); // Send selected visit type to parent
    setOpenState(false);
  };

  return (
    <Dialog open={openState} onClose={() => setOpenState(false)}>
      <DialogTitle>Select Visit Type</DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          row
          name="visitType"
          value={selectedVisitType}
          onChange={(e) => setSelectedVisitType(e.target.value)}
        >
          <Grid2 container spacing={2}>
            <Grid2 item xs={4}>
              <FormControlLabel control={<Radio value="OPD" />} label="OPD" />
            </Grid2>
            <Grid2 item xs={4}>
              <FormControlLabel control={<Radio value="Home" />} label="Home" />
            </Grid2>
            <Grid2 item xs={4}>
              <FormControlLabel control={<Radio value="Online" />} label="Online" />
            </Grid2>
            <Grid2 item xs={4}>
              <FormControlLabel disabled control={<Radio value="IPD" />} label="IPD" />
            </Grid2>
            <Grid2 item xs={4}>
              <FormControlLabel disabled control={<Radio value="Emergency" />} label="Emergency" />
            </Grid2>
          </Grid2>
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenState(false)} variant="outlined" color="inherit">
          Close
        </Button>
        <Button onClick={handleApply} variant="contained" color="secondary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InitialVisitInfo;